import Api from '../Api';

const path = '/site';

const SiteRequests = {
	getSiteData: (version?: number) => {
		return Api.get(path + (version ? '?v=' + version : ''));
	},
};

export default SiteRequests;
